const browserOrigin = typeof window !== 'undefined' ? window.location.origin : ''

export const API_BASE_URL = `${browserOrigin}/api`
